import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common from './public/locales/sk/common.json';
import home from './public/locales/sk/home.json';
import search from './public/locales/sk/search.json';
import listing from './public/locales/sk/listing.json';
import profile from './public/locales/sk/profile.json';
import add_listing from './public/locales/sk/add_listing.json';
import admin from './public/locales/sk/admin.json';

i18n
    .use(initReactI18next)
    .init({
        lng: 'sk',
        fallbackLng: 'sk',
        debug: import.meta.env.DEV,

        // i18next prints a Locize sponsorship notice to the console on init.
        // It is NOT gated on `debug` — the only switch is this flag — so it
        // reached every production visitor's console.
        showSupportNotice: false,

        ns: ['common', 'home', 'search', 'listing', 'profile', 'add_listing', 'admin'],
        defaultNS: 'common',
        fallbackNS: ['common', 'home', 'search', 'listing', 'profile', 'add_listing', 'admin'],

        load: 'languageOnly',

        nsSeparator: ':',
        keySeparator: '.',

        interpolation: {
            escapeValue: false,
        },

        resources: {
            sk: {
                common,
                home,
                search,
                listing,
                profile,
                add_listing,
                admin,
            }
        }
    });

export default i18n;
